module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_landscape-e997d1d3b233a318586eb4878f849434.svg";